module.exports = __webpack_public_path__ + "img/info-1.34e273a6.jpg";